import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';
import { AbstractForm } from '@core/forms/form';


export enum B2bInvoiceFilterFormField {
    Date = 'date',
    StCode = 'stCode',
}

export interface B2bInvoiceFilterFormModel {
    [B2bInvoiceFilterFormField.Date]: FormControl<Date[] | string[]>;
    [B2bInvoiceFilterFormField.StCode]: FormControl<string>;
}

@Injectable()
export class B2bInvoiceFilterFormService extends AbstractForm<B2bInvoiceFilterFormField, B2bInvoiceFilterFormModel> {
    readonly #currentDate: Date = new Date();

    readonly #defaultStartDate: Date = new Date(
        new Date().setMonth(this.#currentDate.getMonth() - 3),
    );

    readonly #defaultEndDate: Date = new Date(
        this.#currentDate.setHours(23, 59, 59),
    );

    public createReactiveForm(): FormGroup<B2bInvoiceFilterFormModel> {
        this.build({
            [B2bInvoiceFilterFormField.Date]: new FormControl<Date[] | string[]>(
                [this.#defaultStartDate, this.#defaultEndDate],
                [Validators.required],
            ),
            [B2bInvoiceFilterFormField.StCode]: new FormControl<string>(null, []),
        });

        return this.form;
    }
}
